import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { Build } from '@material-ui/icons';
import { colors, metrics } from '../../styles';
import { connect } from 'react-redux';
import { setUsers } from '../../actions/usersActions';


class Shedule extends Component {
    constructor(props) {
        super(props)

        this.state = {
            open: '',
            vertical: 'top',
            horizontal: 'center',
            notific: false
        }
    }

    handleClose = () => {
        this.setState({ open: false });
    };

    handleClick = () => {
        this.setState({ notific: !this.state.notific });
    };

    render() {
        return (
            <Grid container justify='center' style={styles.page} >
                <Grid style={{ justifyContent: 'center', color: colors.regular, textAlign: 'center', marginTop: 80 }}>
                    <Build style={{ fontSize: 80 }} />
                    <h1>Em desenvolvimento</h1>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => ({
    users: state.usersReducer.users
})

const mapDispatchToProps = {
    setUsers
};

export default connect(mapStateToProps, mapDispatchToProps)(Shedule)

const styles = {
    page: {
        padding: metrics.paddingPage,
    },
    menuLeft: {

    },
    ibox: {
        backgroundColor: colors.white,
        padding: metrics.padding,
        elevation: 10,
    },
}



// WEBPACK FOOTER //
// ./src/routes/schedule/index.js